<template>
  <el-table-wrapper
    v-loading="isLoading"
    :style="fitHeight ? { height: '100%' } : null"
    :fit-height="fitHeight"
    ref="objTable"
    :data="tableData"
    :total="total"
    :columns="columns"
    :show-search-tool="showSearchTool"
    remote
    pagination
    :show-custom-header="showCustomHeader"
    @condition-change="onConditionChange"
    @select="onSelect"
    @select-all="onSelectAll"
  >
  </el-table-wrapper>
</template>

<script>
import { isEmpty, isNil, filter } from 'lodash';
import logicalGroupApi from '@/api/settings/common/logical-group';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WLogicalObjTable',
  props: {
    height: {
      type: String,
    },
    fitHeight: {
      type: Boolean,
    },
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Boolean,
      default: false,
    },
    exceptDefineIds: {
      type: Array,
      default: () => [],
    },
    // 제외할 objtypeId들을 배열로 정의한다.
    exceptObjtypeIds: {
      type: Array,
    },
    // 필터링할 objDefineId들을 배열로 정의한다.
    objDefineIds: {
      type: Array,
    },
    // 필터링할 objtypeId들을 배열로 정의한다.
    objtypeIds: {
      type: Array,
    },
    // 네트워크 장비를 부모로 가지는 관리 대상 숨김 여부
    hiddenNetdeviceChildren: {
      type: Boolean,
      default: false,
    },
    managegroupData: {
      type: Object,
      default: null,
    },
    showSearchTool: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      showCustomHeader: true,
      tableData: null,
      total: null,
      columnDefault,
      columns: [
        {
          type: 'selection',
          width: 55,
        },
        {
          prop: 'objDefineName',
          label: '관리구분',
          width: 110,
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'objName',
          label: '대상명',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          width: 120,
          searchable: true,
          formatter: defaultFormatter,
        },
      ],
    };
  },
  watch: {
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.loadData();
        }
      },
    },
    managegroupData: {
      handler(value) {
        if (!isNil(value)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.$refs.objTable.clearFilter();
      this.$emit('change-search-tool');
      this.tableData = [];
    },
    loadData() {
      if (!this.active) {
        return;
      }
      this.isLoading = true;
      const tableParams = {
        managegroupIds: isNil(this.managegroupData) ? null : this.managegroupData.childManagegroupIds,
        ...this.$refs.objTable.getParameter(),
      };
      if (!isEmpty(this.exceptDefineIds)) {
        tableParams.exceptDefineIds = this.exceptDefineIds;
      }
      if (!isEmpty(this.exceptObjtypeIds)) {
        tableParams.exceptObjtypeIds = this.exceptObjtypeIds;
      }
      if (!isEmpty(this.objDefineIds)) {
        tableParams.objDefineIds = this.objDefineIds;
      }
      if (!isEmpty(this.objtypeIds)) {
        tableParams.objtypeIds = this.objtypeIds;
      }
      if (this.hiddenNetdeviceChildren) {
        tableParams.hiddenNetdeviceChildren = this.hiddenNetdeviceChildren;
      }
      logicalGroupApi
        .getLogicalObjList(tableParams)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            result.data.forEach((row) => {
              const checkedObj = this.checkedObjList.find((obj) => obj.objId === row.objId);
              row.checked = !isNil(checkedObj) ? 1 : 0;
            });
            this.tableData = result.data;
            this.total = result.total;
            const originalData = filter(result.data, (item) => item.checked);
            this.originTableData = originalData;
            this.$nextTick(() => {
              this.toggleRowSelection(originalData);
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          // this.managegrpObjData.loading = false;
          this.tableData = [];
          this.total = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onConditionChange() {
      this.loadData();
    },
    onSelect(selection, row) {
      this.$emit('change-obj-list', [row], !isNil(selection.find((item) => item.objId === row.objId)));
    },
    onSelectAll(selection) {
      this.$emit('change-obj-list', this.tableData, selection.length > 0);
    },
    /**
     * 선택된 데이터 배열 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getSelection() {
      return this.$refs.objTable.getTable().selection;
    },
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        this.$refs.objTable.getTable().toggleRowSelection(row);
      });
    },
    clearSelection() {
      this.$refs.objTable.getTable().clearSelection();
    },
    setCheckObjTable() {
      if (!isNil(this.tableData)) {
        this.tableData.forEach((row) => {
          const checkedObj = this.checkedObjList.find((obj) => obj.objId === row.objId);
          row.checked = !isNil(checkedObj) ? 1 : 0;
        });
        const originalData = filter(this.tableData, (item) => item.checked);
        this.$nextTick(() => {
          this.clearSelection();
          this.toggleRowSelection(originalData);
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/table/CheckObjTable/components/LogicalObjTable.vue